<template>
  <div
    :class="`collections-${theme}-common-hexagon`"
    class="year-badge"
  >
    <YearIcon
      class="icon"
      :year="collection ? collection.year : null"
    />
  </div>
</template>
<script>
import YearIcon from '@/components/common/icons/YearIcon.vue';

export default {
  name: 'YearBadge',
  components: {
    YearIcon,
  },
  props: {
    collection: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    theme() {
      return this.collection ? this.collection.theme : this.$store.state.theme;
    },
  },
};
</script>
<style lang="stylus" scoped>
div.year-badge {
  display: flex
  align-items: center
  justify-content: center
  .icon {
    color: var(--main-color);
    margin: 0 1px 1px 0;
  }
}
</style>
